"use client"
import React from "react";
import Image from "next/image";
import { useRouter } from "next/navigation";

function NotFoundPage() {
  const router = useRouter();

  return (
    <div className="d-flex flex-column align-items-center justify-content-center vh-100 text-center px-3">
      <Image src="/svg/404.svg" alt="404 Not Found" width={320} height={320} priority />
      <h3 className="mt-4 mb-2">Looks like nothing is here.</h3>
      <p className="text-muted mb-3">
        The page you&apos;re looking for doesn&apos;t exist or may have been moved.
      </p>
      <button className="btn btn-link p-0" onClick={() => router.back()}>
        &larr; Go back
      </button>
    </div>
  );
}

export default NotFoundPage;
